import { inject, Injectable } from '@angular/core';
import { BizzMineLocalStorageService } from './bizzmine-local-storage.service';
import { BizzMineSessionStorageService } from './bizzmine-session-storage.service';
import { PwaService } from 'src/app/core/services/pwa/pwa.service';

@Injectable({
  providedIn: 'root'
})
export class BizzMineStorageService {
  public localStorage = inject(BizzMineLocalStorageService);
  public sessionStorage = inject(BizzMineSessionStorageService);
  public isPwa = inject(PwaService).isPwa();
  
  public getStorage(): Storage {
    if(this.isPwa){
      return this.localStorage;
    }else {
      return this.sessionStorage;
    }
  }

}
